import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MtmAuthComponent } from '@mtm/auth-ui-angular';

/**
 * No output bindings by design: `mtm-auth` runs the whole sign-in shell —
 * email lookup, password, magic-link passcode, 2FA, sign-up and password
 * reset — and hands the finished session to the app through
 * `MTM_ON_LOGIN_SUCCESS` / `MTM_ON_APP_TOKEN_READY` in `app.config.ts`.
 */
@Component({
  selector: 'mtm-login-page',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MtmAuthComponent],
  template: `<mtm-auth />`,
  styles: `
    :host {
      display: block;
      min-height: 100vh;
    }
  `,
})
export class LoginPageComponent {}
